export const stockValueReportSubMenu = [{
  path: '/report/stock-value',
  component: () => import('@/views/report/stock-value-report/list.vue'),
  name: 'report.stockValue',
  hidden: true,
  meta: {
    title: 'report.stockValue.title',
    noCache: true,
    icon: 'chart',
    hidden: true
  }
}];